import { FlightRect } from "v2/utils/useFilingFlights";

const LANDING_INSET_X = 18;
const LANDING_INSET_Y = 6;

const clampTopToList = (
  list: HTMLElement,
  top: number,
  height: number
): number => {
  const listRect = list.getBoundingClientRect();
  const maxTop = Math.max(listRect.bottom - height, listRect.top);

  return Math.min(Math.max(top, listRect.top), maxTop);
};

const listFallbackRect = (list: HTMLElement): FlightRect => {
  const listRect = list.getBoundingClientRect();

  return {
    left: listRect.left + LANDING_INSET_X,
    top: listRect.top + LANDING_INSET_Y,
    width: Math.max(listRect.width - LANDING_INSET_X * 2, 0),
    height: 0,
  };
};

const isRendered = (rect: DOMRect): boolean =>
  rect.width > 0 || rect.height > 0;

const findVisibleNeighbour = (row: HTMLElement): HTMLElement | null => {
  let sibling = row.previousElementSibling;

  while (sibling instanceof HTMLElement) {
    if (isRendered(sibling.getBoundingClientRect())) return sibling;
    sibling = sibling.previousElementSibling;
  }

  return null;
};

const rectFromNeighbour = (
  list: HTMLElement,
  row: HTMLElement,
  shouldClamp: boolean
): FlightRect => {
  const neighbour = findVisibleNeighbour(row);

  if (!neighbour) return listFallbackRect(list);

  const neighbourRect = neighbour.getBoundingClientRect();

  return {
    left: neighbourRect.left,
    top: shouldClamp
      ? clampTopToList(list, neighbourRect.bottom, neighbourRect.height)
      : neighbourRect.bottom,
    width: neighbourRect.width,
    height: neighbourRect.height,
  };
};

export const getFilingRowRect = (
  list: HTMLElement | null,
  filingId: string,
  shouldClamp = true
): FlightRect | null => {
  if (!list) return null;

  const row = list.querySelector<HTMLElement>(`[data-filing-id="${filingId}"]`);

  if (!row) return listFallbackRect(list);

  const rowRect = row.getBoundingClientRect();

  if (!isRendered(rowRect)) return rectFromNeighbour(list, row, shouldClamp);

  return {
    left: rowRect.left,
    top: shouldClamp
      ? clampTopToList(list, rowRect.top, rowRect.height)
      : rowRect.top,
    width: rowRect.width,
    height: rowRect.height,
  };
};
